import { connect } from 'react-redux';
import { filter } from 'ramda';

import ChatPanel from './ChatPanel';
import { getMessages, markAsRead, joinChannel, clearUnreadCount, saveScrollPosition, showChat } from '../../actions/chatActions';

const mapStateToProps = (state, ownProps) => {
  const chatId = parseInt(ownProps.match.params.chatId, 10);
  const chat = state.chats[chatId];
  return {
    chatId,
    chat,
    users: state.users,
    messages: filter(message => message.chatId === chatId, state.messages),
    selectedMessages: state.selectedMessages[chatId] || {},
    messagesPaging: state.messagesPaging,
    publicChannels: state.publicChannels,
    identityId: state.identity.id,
    scrollPosition: chat ? chat.scrollPosition : null,
  };
};

const mapDispatchToProps = dispatch => ({
  getMessages: (chatId, page) => dispatch(getMessages(chatId, page)),
  markAsRead: (chatId, messageIds) => dispatch(markAsRead(chatId, messageIds)),
  joinChannel: chatId => dispatch(joinChannel(chatId)),
  showChat: chatIds => dispatch(showChat(chatIds)),
  clearUnreadCount: chatId => dispatch(clearUnreadCount(chatId)),
  saveScrollPosition: (chatId, scrollTop) => dispatch(saveScrollPosition(chatId, scrollTop))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatPanel);
